var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavBtnAudioOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.024 3.91968V0H8.03204V5.91165L10.024 3.91968Z",
    fill: "#AE0955"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97585 7.96786V2.95581H3.98389V9.95983L5.97585 7.96786Z",
    fill: "#AE0955"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99197 5.97595H0V9.95989H1.99197V5.97595Z",
    fill: "#AE0955"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.992 5.97595H16V9.95989H17.992V5.97595Z",
    fill: "#AE0955"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03204 12.0803V16H10.024V10.0884L8.03204 12.0803Z",
    fill: "#AE0955"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0161 8.09634V12.9799H14.0081V6.10437L12.0161 8.09634Z",
    fill: "#AE0955"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9805 1.63892L2.66693 12.9525L4.07545 14.361L15.3891 3.04744L13.9805 1.63892Z",
    fill: "#AE0955"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBtnAudioOff);
export default __webpack_public_path__ + "static/media/nav_btn_audio_off.43d13e0afc136d32b6d3cc905a3bced5.svg";
export { ForwardRef as ReactComponent };